import styled from 'styled-components'

import colors from './colors'

const Header = styled.div`
  padding: 1rem 0 2rem;
`
const StickyMobileHeader = styled.div`
  padding: 1rem 0;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
  margin: -2rem 0 0; /* make up for page padding */
  border-bottom: 1px solid ${colors.lightGray};
`
const Page = styled.div`
  padding: 2rem 0;
  max-width: 600px;
  margin: auto;
`
const Footer = styled.div`
  padding: 2rem 0;
  text-align: center;
`

export {
  Header,
  StickyMobileHeader,
  Page,
  Footer,
}



// WEBPACK FOOTER //
// ./src/styles/layout.js